import React, { useEffect, useState, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { commonBackInfo, upperAndLowerFuzzyQuery } from '../../utils';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { genreGamePlaceholder } from '../../constants/placeholder';
import type { GameListType } from '../../types';
import { getInfluencerGenreGameCovereds } from '@op/services';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function GenreGameListSelect({
  onChange,
  defaultValue,
  filterValue,
  gameInfo,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: GameListType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const [gameOptions, setGameOptions] = useState([]);

  useEffect(() => {
    if (!gameInfo?.edition_unified_id) return;
    getInfluencerGenreGameCovereds(gameInfo).then((data: any) => {
      const { genre_game } = data || {};
      setGameOptions(
        (genre_game || []).map((item: any) => {
          return {
            text: item.entity_name,
            icon: item.cover,
            value: item.edition_unified_id,
          };
        }),
      );
    });
  }, [gameInfo]);

  const selectOptions = useMemo(() => {
    return upperAndLowerFuzzyQuery(gameOptions, searchValue);
  }, [gameOptions, searchValue]);

  const basicOptionsList = useMemo(() => {
    return gameOptions.map((item: any) => item.value);
  }, [gameOptions]);
  const {
    selects: selectGameList,
    setSelects: setSelectGameList,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: 'game_covereds',
    options: basicOptionsList,
    watchOptions: true,
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'genreGameList',
      commonBackInfo(
        { game_covereds: selectGameList },
        { genreGameList: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [selectGameList, basicOptionsList]);

  return (
    <div className={`genre-game-list-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        searchInfo={[searchValue, setSearchValue]}
        placeholderText={genreGamePlaceholder[lang]}
        onClear={() => setSelectGameList([])}
        selectOptionsInfo={[selectGameList, setSelectGameList]}
        options={selectOptions}
        showNumber={1}
        matchButtonWidth={false}
        basicOptions={gameOptions}
        pointKey={FilterButtonPoint.genreGameList}
        boxClassName="genre-game-list-select"
        optionItemRender={(text: string, _value: any, item: any) => {
          const icon = item.icon;
          return (
            <div className="genre-game-list-select-item">
              <img src={icon} style={{ width: 24, height: 24 }} />
              <span className="genre-game-list-select-item-text">{text}</span>
            </div>
          );
        }}
      ></CustomSelect>
    </div>
  );
}
